import { Box, Stack } from '@mui/material';
import ratingStartIcon from 'assets/icons/rating-star.svg';

const RatingStars = ({ rating }: { rating: number }) => (
  <Stack flexDirection="row" gap={0.25}>
    {Array.from({ length: rating }, (_, index) => (
      <Box component="img" src={ratingStartIcon} key={index} alt="star" />
    ))}
  </Stack>
);

export default RatingStars;
